import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Logo from '../assets/logo/logo.png'
import { faBars, faRepeat } from '@fortawesome/free-solid-svg-icons';
import NFTMarketPlaceNavBar from './NFTMarketPlace/components/NFTMarketPlaceMenu';
import { useDarkModeManager } from '../state/user/hooks';
import WalletStatus from './NFTMarketPlace/components/WalletStatus';
import { useHistory } from 'react-router-dom';
import { Moon, Sun } from 'react-feather';

const HeaderWrapper = styled.div`
    ${({ theme }) => theme.flexRowNoWrap}
    width: 100%;
    height: 70px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10%;
    background-color: ${({ theme }) => theme.newBg2};
    .hamburgerIcon {
        height: 70px !important;
        width: 80px !important;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        cursor: pointer;
    }
    ${({ theme }) => theme.mediaWidth.upToLarge`
        padding: 0;
    `};
`;

const HideLarge = styled.span`
    ${({ theme }) => theme.mediaWidth.upToLarge`
        display: none;
    `};
`

const ShowLarge = styled.span`
    display: none;
    ${({ theme }) => theme.mediaWidth.upToLarge`
        display: block;
    `};
`

const HeaderSection = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 1rem;

    > img {
        cursor: pointer;
    }

   
`;

const OldUISwitcher = styled.a`
    width: 60px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 0.8rem;
    color: ${({ theme }) => theme.text1};
    text-decoration: none;

    .oldUIIcon {
        cursor: pointer;
        margin-right: 5px;
    }

    ${({ theme }) => theme.mediaWidth.upToSmall`
        display: none;
    `};
`

const DarkModeSwitcher = styled.div`
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 50%;
    &:hover {
        background-color: ${({ theme }) => theme.newBg1};
        box-shadow: 0px 0px 10px 0px ${({ theme }) => theme.newBg1};
    }
`

const Header = (props: any) => {
    const [darkMode, toggleDarkMode] = useDarkModeManager()
    const navigate = useHistory();

    const onClickHome = () => {
        navigate.push('/');
    }

    return (
        <HeaderWrapper >
            <HeaderSection>
                <ShowLarge>
                    <div onClick={() => {
                        props.onClickMenu();
                    }} className="hamburgerIcon"><FontAwesomeIcon icon={faBars} size={"1x"} /></div>
                </ShowLarge>
                <img width={'50px'} src={Logo} alt="logo" onClick={onClickHome} />
                <HideLarge>
                    <NFTMarketPlaceNavBar />
                </HideLarge>
            </HeaderSection>

            <HeaderSection>
                <DarkModeSwitcher onClick={toggleDarkMode}>
                    {darkMode ? <Moon size={24} /> : <Sun size={24} />}
                </DarkModeSwitcher>
                <WalletStatus />
            </HeaderSection>
        </HeaderWrapper>
    )
}
export default Header;